import { Component } from 'preact';
import { Link } from 'preact-router/match';
import styled from 'styled-components';

class Footer extends Component {

	scrollToId = (id) => {
		let element = document.getElementById(id);
		element.scrollIntoView({
			behavior: 'smooth',
			block: 'start'
		});
	}

	constructor(props) {
		super(props);
		this.state = {
			language: null
		};
	}

	render() {
		
		const FooterContainer = styled.div`
			background: ${this.context.colors.primary};
			box-sizing: border-box;
			min-height: 24.5rem;
			padding-top: 5.5rem;
			@media only screen and (max-width: 1200px) {
				padding-top: 4rem;
			}
			@media only screen and (max-width: 680px) {
				min-height: auto;
			}
			.wrapper {
				display: flex;
				margin: 0 auto;
				max-width: 120rem;
				width: 100%;
				@media only screen and (max-width: 1200px) {
					align-items: center;
					flex-direction: column;
					justify-content: center;
				}
				.email {
					color: #FFFFFF;
					font-size: 1.2rem;
					text-transform: uppercase;
					span{
						text-transform: lowercase;
					}
				}
				.studio-ad {
					display: flex;
					max-width: 62rem;
					width: 100%;
					@media only screen and (max-width: 1200px) {
						align-items: center;
						justify-content: center;
						max-width: 100%;
					}
					@media only screen and (max-width: 680px) {
						flex-direction: column;
					}
					img {
						height: auto;
						max-height: 10rem;
						max-width: 23.9rem;
						width: 100%;
						@media only screen and (max-width: 680px) {
							display: none;
						}
					}
					p {
						align-items: center;
						display: flex;
						font-size: 1rem;
						justify-content: center;
						line-height: 3;
						color: ${this.context.colors.link};
						margin: 0 0 0 3.2rem;
						max-width: 36rem;
						width: 100%;
						@media only screen and (max-width: 680px) {
							text-align: center;
							line-height: 2;
							margin: 0;
							padding: 0 2rem 5rem 2rem;
						}
					}
				}
			}
			.legal {
				margin: 2rem 0 2rem 0;
				border-top: .1rem solid rgba(255,255,255,.25);
				padding-top: 2rem;
				color: ${this.context.colors.link};
				font-size: 1.1rem;
			}
			.legal-links {
				a {
					text-transform: initial;
				}
			}
			.links-wrapper {
				margin-left: auto;
				@media only screen and (max-width: 1200px) {
					margin-bottom: 4rem;
					margin-left: initial;
					order: -1;
					padding: 0 2rem;
				}
				a {
					color: ${this.context.colors.link};
					cursor: pointer;
					font-size: 1.2rem;
					text-decoration: none;
					text-transform: uppercase;
					&:not(:last-of-type) {
						margin-right: 5rem;
					}
					&:hover {
						color: ${this.context.colors.hoverLink};
					}
				}
			}
		`;

		return (
			<FooterContainer>
				<div className="wrapper">
					<div className="studio-ad">
						<img src={this.context.branding.logoLarge} alt={this.context.copy.longName} />
						{ this.context.copy.footerCopy &&
							<p>{this.context.copy.footerCopy}</p>
						}
					</div>
					<div className="links-wrapper" id="footer">
						<Link activeClassName="active" onClick={()=>this.scrollToId('careers')}>Careers</Link>
						<Link activeClassName="active" onClick={()=>this.scrollToId('studio')}>Our Studio</Link>
						<p className = "email" > Contact us at: <span> titanforgegames@hirezstudios.com </span> </p>
						<div className="legal">
						©  2018 Hi-Rez Studios, Inc. "SMITE", "Battleground of the Gods", "Titan Forge Games", and "Hi-Rez Studios" are trademarks or registered trademarks of Hi-Rez Studios, Inc. in the U.S. and/or other countries. All trademarks and copyright material are property of their respective owners. All rights reserved.
						</div>
						<div className="legal-as">
							<a activeClassName="active" target="_blank" href="https://www.hirezstudios.com/privacypolicy">Privacy Policy</a>
							<a activeClassName="active" target="_blank" href="https://webcdn.hirezstudios.com/hirez-studios//wp-content/uploads/2015/11/Hi-Rez-Studios-Terms-of-Service-and-Use-Agreement-7-12-2018.pdf">Terms of Service</a>
						</div>
					</div>
				</div>
			</FooterContainer>
		);
	}
}

export default Footer;


// WEBPACK FOOTER //
// ./components/Footer.js